import { CustomButton } from "../global/CustomButton"
import { SectionTitle } from "../global/SectionTitle"
import { Product } from "../global/Product"
import "./bestProducts.css"
import { useContext } from "react"
import { ProductsContext } from "../../contexts/ProductsContext"

export function BestProducts(){
    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    return (
        <div className="best-products-section">
            <SectionTitle title="This Month" />

            <div className="d-flex justify-content-between align-items-center my-3 md-row gap-3">
                <p className="my-auto me-auto section-title">Best Selling Products</p>
                <CustomButton
                    btnLink={true}
                    path="/shop"
                    text="View All"
                    color="primary"
                />
            </div>

            <div className="d-flex flex-wrap mt-5 best-products justify-content-between">

                {
                    products && products.filter((a, j) => !a.discount && j < 5).map((e, i) => (
                        <Product
                            key={i}
                            id={e._id}
                            name={e.title}
                            image={e.image}
                            regularPrice={e.regularPrice}
                            salePrice={e.salePrice}
                            discount={e.discount && e.discount}
                            rating={e.rating.rate}
                            reviews={e.rating.reviews}
                        />
                    ))
                }

            </div>

        </div>
    )
}